/**
 * Default state.
 * @type {import("./types").DefaultStateInterface}
 */
const default_state =  {
    loadingApplication: true,
    token: null,
    locale: 'fr',
    layout: {
        header: true,
        sidebar: true,
        container: true,
        intercom: true
    },
    sidebar: { section: null },
    user: null,
    account: null
};

export default default_state;